import { ComponentProps } from 'preact';

import { cn } from '@/lib/utils';

type ProductCardCheckoutGroupProps = ComponentProps<'div'>;

/**
 * The purchase button and the refusal that answers it, held closer together than the panel's own
 * spacing would hold them: the line is about that button, not another item below the list. Matches
 * the grouping zl-api's `CheckoutButton` does internally.
 */
const ProductCardCheckoutGroup = ({ className, children, ...props }: ProductCardCheckoutGroupProps) => (
  <div
    className={cn('flex w-full flex-col items-center gap-3', className)}
    // eslint-disable-next-line react/jsx-props-no-spreading
    {...props}
  >
    {children}
  </div>
);

export default ProductCardCheckoutGroup;
